// extracted by mini-css-extract-plugin
export default {"groupContainer":"fAKzr","groupContent":"yApkU"};